import { SearchResultConfigModel } from "./models/search-result-config.model";
import { SearchInputConfigModel } from "./models/search-input-config.model";

/**
 * A configuration model for the dynamic listing preview
 */
export class SearchConfigModel {

  //search displays
  public agentOffice: SearchInputConfigModel = new SearchInputConfigModel({
    agentDisplay: [ { key: 'memberFullName' }, { key: 'memberEmail' }, { key: 'memberPhone' }, { key: 'memberStateLicense' , label: 'License #' } ],
    officeDisplay: [ { key: 'officeName' }, { key: 'officeAddress' }, { key: 'officeEmail' }, { key: 'officePhone' }, { key: 'officeStateLicense' , label: 'License #' } ]
  });
  public buyerAgentOffice: SearchInputConfigModel = new SearchInputConfigModel({
    agentDisplay: [ { key: 'memberFullName' }, { key: 'memberEmail' }, { key: 'memberPhone' }, { key: 'memberStateLicense' , label: 'License #' } ],
    officeDisplay: [ { key: 'officeName' }, { key: 'officeAddress' }, { key: 'officeEmail' }, { key: 'officePhone' }, { key: 'officeStateLicense' , label: 'License #' } ]
  });

  //search results
  public agent: SearchResultConfigModel = new SearchResultConfigModel({ display: 'memberEmail' });
  public buyerAgent: SearchResultConfigModel = new SearchResultConfigModel({ display: 'memberEmail', displayLeft: 'officeName', displayRight: 'officeAddress' });
  public office: SearchResultConfigModel = new SearchResultConfigModel({ display: 'officePhone', displayLeft: 'officeAddress' });
  public buyerOffice: SearchResultConfigModel = new SearchResultConfigModel({ display: 'officePhone', displayLeft: 'officeAddress' });

  constructor(model?: Partial<SearchConfigModel>) {
    if (model)
      for (let key in this as SearchConfigModel)
        if (model[key]) {
          if (this[key] instanceof SearchResultConfigModel)
            this[key] = new SearchResultConfigModel(model[key]);
          else if (this[key] instanceof SearchInputConfigModel)
            this[key] = new SearchInputConfigModel(model[key]);
        }          
  }
}
